// extracted by mini-css-extract-plugin
export default {"fr-view":"Finder_fr-view__vu9DO","group":"Finder_group__qJlvK"};